import Vue from 'vue';
import VueResource from 'vue-resource';

import converterObjetoFormData from '~js/converter-objeto-formdata';

Vue.use(VueResource);

function normalizarParaSalvar(mensagem) {
  delete mensagem.mensagemArea;
  
  return mensagem;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    return Vue.http.get('/api/mensagem', { params: parametros });
  },
  listaChat: filtros => {
    return Vue.http.get('/api/mensagem/listachat',
      {
        params: {
          id: filtros.id,
          modulo: filtros.modulo,
          internaexterna: filtros.internaexterna,
        }
      })
      .then(resposta => resposta.body);
  },
  listaDeModulos: function () {
    return Vue.http.get('/api/mensagem/listamodulos').then(response => response.data);
  },  
  salvar: mensagem => {
    mensagem = normalizarParaSalvar(mensagem);
    const parametros = Object.assign({}, { }, mensagem);
    mensagem = converterObjetoFormData(parametros);
    return Vue.http.post('/api/mensagem',  mensagem ).then(res => res.data.id);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/mensagem/servico.js